export default __webpack_public_path__ + "static/media/08.42004cf2.gif";